import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from 'react-i18next'
import { useModuleActions } from '../../../hooks/useMyPermissions'
import { cn } from '@/lib/utils'

const colorMap = {
  success: 'default',
  warning: 'destructive',
  info: 'outline',
}

export default ({ actions, onAction, loading, disabled, datesInvalid, inline, projectId }) => {
  const { t } = useTranslation()
  const [lastAction, setLastAction] = useState('')
  const { canApprove } = useModuleActions('PROCUREMENT', projectId)

  const buttons = {
    submit: {
      title: t('Tender_tender_action_submit_btn', 'Submit for approval'),
      color: 'success',
    },
    revise: {
      title: t('Tender_tender_action_send_to_revise_btn', 'Send to revise'),
      color: 'warning',
    },
    approve: { title: t('Tender_tender_action_approve_btn', 'Approve'), color: 'success' },
    run: { title: t('Tender_tender_action_run_tender_btn', 'Run the tender'), color: 'success' },
    award: { title: t('Tender_tender_action_award_btn', 'Award'), color: 'success' },
    reopen: { title: t('Tender_tender_action_reopen_btn', 'Reopen tender'), color: 'info' },
    nextRound: {
      title: t('Tender_tender_action_open_next_round_btn', 'Open next round'),
      color: 'info',
    },
  }

  const handleAction = (action) => {
    onAction(action)
    setLastAction(action)
  }

  if (!canApprove) return null

  return (
    <div className={cn('flex gap-2', !inline && 'flex-wrap xl:flex-col')}>
      {actions.sort().map((t, i) => (
        <Button
          key={i}
          variant={colorMap[buttons[t].color] || 'default'}
          disabled={
            loading || disabled || (datesInvalid && ['nextRound', 'approve'].indexOf(t) > -1)
          }
          className={inline ? '' : 'xl:w-full'}
          onClick={() => handleAction(t)}
        >
          {loading && t === lastAction && <Spinner size="sm" className="text-current" />}
          {buttons[t].title}
        </Button>
      ))}
    </div>
  )
}
